export default __webpack_public_path__ + "static/media/theme-color.e8dcee38.svg";